export default __webpack_public_path__ + "893cec2eb17d2b0181100808b08e524d.svg";